import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2.5 mb-4">
                <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-book-read-line text-lg text-background-50"></i>
                </div>
                <span className="text-lg font-bold text-background-50 font-heading whitespace-nowrap">
                  韩漫在线
                </span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                韩漫网提供免费韩国漫画大全，支持全集下拉式阅读，让您在线畅读各种韩漫。
              </p>
              <div className="flex items-center gap-3 mt-5">
                <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center text-background-300 hover:text-background-50 hover:bg-primary-500 transition-all cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center text-background-300 hover:text-background-50 hover:bg-primary-500 transition-all cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center text-background-300 hover:text-background-50 hover:bg-primary-500 transition-all cursor-pointer" aria-label="QQ">
                  <i className="ri-qq-line text-base"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">快速导航</h4>
              <ul className="space-y-2.5">
                {['首页', '热门推荐', '最新更新', '分类浏览'].map((item) => (
                  <li key={item}>
                    <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                      {item}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">热门分类</h4>
              <ul className="space-y-2.5">
                {['热血漫画', '恋爱漫画', '奇幻漫画', '武侠漫画'].map((item) => (
                  <li key={item}>
                    <Link to="/category/rexue" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                      {item}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">关于我们</h4>
              <ul className="space-y-2.5">
                {['品牌介绍', '联系方式', '用户协议', '隐私政策'].map((item) => (
                  <li key={item}>
                    <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                      {item}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; 2026 韩漫在线 HanMan Online. All rights reserved.
            </p>
            <p className="text-xs text-background-500">
              <strong>韩漫在线</strong> - 免费韩国漫画大全，畅享下拉式阅读体验
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}